import { BrandWordmark } from "@carepass/ui";
import memberSymbolUrl from "../../assets/brand/carepass-symbol-512.png";
import "./MemberBrand.css";

export function MemberBrand({ className }: { readonly className?: string }) {
  return (
    <span className={["member-brand-lockup", className].filter(Boolean).join(" ")}>
      <img className="member-brand-lockup__symbol" src={memberSymbolUrl} width={32} height={32} alt="" />
      <BrandWordmark />
    </span>
  );
}
